import PropTypes from 'prop-types';
import React from 'react';
import { useEffect } from 'react';
import {
  sessionPasswordlessTerminated,
  silentPasswordlessRenewError,
  userPasswordlessExpired,
  userPasswordlessFound,
  userPasswordlessSignedOut,
} from 'shared/redux/passwordlessOidcSlice';

export const PasswordlessOidcProvider = (props) => {
  const { userManager, store } = props;

  // event callback when the user has been loaded (on silent renew or redirect)
  const onUserLoaded = (user) => {
    store.dispatch(userPasswordlessFound(user));
  };

  // event callback when silent renew errored
  const onSilentRenewError = (error) => {
    store.dispatch(silentPasswordlessRenewError());
  };

  // event callback when the access token expired
  const onAccessTokenExpired = () => {
    store.dispatch(userPasswordlessExpired());
  };

  // event callback when the user is logged out
  const onUserUnloaded = () => {
    store.dispatch(sessionPasswordlessTerminated());
  };

  // event callback when the user is signed out
  const onUserSignedOut = () => {
    store.dispatch(userPasswordlessSignedOut());
  };

  useEffect(() => {
    userManager.events.addUserLoaded(onUserLoaded);
    userManager.events.addSilentRenewError(onSilentRenewError);
    userManager.events.addAccessTokenExpired(onAccessTokenExpired);
    userManager.events.addUserSignedOut(onUserSignedOut);

    return () => {
      userManager.events.removeUserLoaded(onUserLoaded);
      userManager.events.removeSilentRenewError(onSilentRenewError);
      userManager.events.removeAccessTokenExpired(onAccessTokenExpired);
      userManager.events.removeUserSignedOut(onUserSignedOut);
    };
  }, []);

  return <>{props.children}</>;
};

PasswordlessOidcProvider.propTypes = {
  userManager: PropTypes.object.isRequired,
  // the redux-store
  store: PropTypes.object.isRequired,
};
